import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionCustom } from "../../../api/transaction-type";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  salesOrderFAMDepreciationHistoryTable,
  salesOrderFamAssetTable,
  salesOrderCustomJournalRejectReasonTable,
} from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormGroup,
  Tabs,
  Tab,
  MenuItem,
  Select,
  Stack,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";

export default function SalesOrderCustom({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  useEffect(() => {
    if (user.token && tabIndexP === 8) {
      getTransactionCustomDetailData();
    }
  }, [tabIndexP]);

  async function getTransactionCustomDetailData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCustom(user.token, {
        id: params.docNo,
      });
      // console.log("jhsjjs", data.data.data[0]);
      setRowData(data.data.data);
      setLoading(false);
      // return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      // return { error: true };
    } finally {
      setLoading(false);
    }
    // setRowData([]);
  }
  async function getTransactionCustomData() {
    // setLoading(true);
    // try {
    //   const { data } = await getTransactionCustom(user.token, {
    //     id: params.docNo,
    //   });
    //   setRowData(data.data.data);
    //   setLoading(false);
    //   return { rows: data.data.data, total: data.data.total, error: false };
    // } catch (error) {
    //   console.log(error);
    //   setLoading(false);
    //   snackbar.showError("Error In Loading Data.");
    //   return { error: true };
    // } finally {
    //   setLoading(false);
    // }
    // setRowData([]);
  }
  return (
    <>
      {rowData?.map((el, index) => (
        <Box className="viewDetilsBox">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">OPPROTUNITY NUMBER</p>
              <p className="tFormName">{el.opportunity_number}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">OPENAIR INVOICE TAX AMOUNT</p>
              <p className="tFormName">{el.openair_invoice_tax_amount}</p>
            </Grid>
            {el.helix === "F" || el.helix === "" ? (
              <Grid item xs={12} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel control={<checkbox  disabled/>} label="HELIX" />
                  </FormGroup>
                </p>
              </Grid>
            ) : (
              <Grid item xs={12} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked />}
                      label="HELIX"
                    />
                  </FormGroup>
                </p>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">CRM QUOTE ID</p>
              <p className="tFormName">{el.crm_quote_id}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">OPENAIR INVOICE TAX</p>
              <p className="tFormName">{el.openair_invoice_tax_amount}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormName">BUSINESS UNIT</p>
              <p className="tFormName">{el.business_unit}</p>
            </Grid>
            {el.asc_606_invoice_replacement === "F" ||
            el.asc_606_invoice_replacement === "" ? (
              <Grid item xs={12} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<checkbox  disabled/>}
                      label="ASC 606 INVOICE REPLACEMENT"
                    />
                  </FormGroup>
                </p>
              </Grid>
            ) : (
              <Grid item xs={12} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked />}
                      label="ASC 606 INVOICE REPLACEMENT"
                    />
                  </FormGroup>
                </p>
              </Grid>
            )}
            {/* <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={<checkbox  disabled/>}
                  label="ASC 606 INVOICE REPLACEMENT"
                />
              </FormGroup>
            </Grid> */}
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">OPENAIR: EXPORT ERROR</p>
              <p className="tFormName">{el.openair_export_error}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">DO NOT MIGRATE TO QUORUM</p>
              <p className="tFormName">{el.do_not_migrate_to_quorum}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">OPENAIR INVOICE NUMBER</p>
              <p className="tFormName">{el.openair_invoice_number}</p>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">APPROVED BY_</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SALESFORCE ID (2)</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SF ORDER INVOICE INSTRUCTIONS</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">CREATED BY SFDC</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">CELIGO END USER SWAP FIELD[CR]</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SF ORDER NUMBER</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">BILLING SCHEDULE REVIEW</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
        
              <FormGroup>
                <FormControlLabel
                  control={<checkbox  disabled/>}
                  label="SEND TO SALESFORCE"
                />
              </FormGroup>
              <p className="tFormName">SALESFORCE QUOTE ID</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SF ESCALATION%</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={<checkbox  disabled/>}
                  label="SERVICE ORDER"
                />
              </FormGroup>
              <p className="tFormName">REVIEW STATUS</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={<checkbox  disabled/>}
                  label="SEND SALES ORDER TO SALESFORCE"
                />
              </FormGroup>
     
              <p className="tFormName">SALESFORCE ORDER ID</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">
                SFDC BILLING INSTRUCTIONS PER CLIENT RECORD
              </p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">ORDER REVIEW SEARCH</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">CLIENT PROVER MAINTENANCE</p>
              <p className="tFormName"></p>
            </Grid>

            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SFDC ORDER QUID</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">BILLING REVIEW SEARCH</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <FormGroup>
                <FormControlLabel control={<checkbox  disabled/>} label="PRORATED" />
              </FormGroup>
              <p className="tFormName">CONTRACT DAYS BEFORE RENEWAL</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">NETSUITE INTERNAL ID</p>
              <p className="tFormName">3931</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">DATA MIGRATION FROM</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={8} className="m-b-10">
              <p className="tFormlabel"></p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">OPENAIR INVOICE ID</p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={8} className="m-b-10">
              <p className="tFormlabel"></p>
              <p className="tFormName"></p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">REVIEWER BUSINESS UNIT</p>
              <p className="tFormName"></p>
            </Grid> */}
          </Grid>
        </Box>
      ))}
      <Box>
        {/* <Box
          px={2}
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
      
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label="FAM Asset" />
            <Tab label="Journal Reject Reason" />
            <Tab label="FAM Depreciation History" />
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
   
            <Box className="viewDetilsBox">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Alternate Depreciation History">
                        Alternate Depreciation History
                      </MenuItem>
                      <MenuItem value="Custom Default View">
                        Custom Default View
                      </MenuItem>
                      <MenuItem value="Default View">Default View</MenuItem>
                      <MenuItem value="Depreciation History">
                        Depreciation History
                      </MenuItem>
                      <MenuItem value="FAM Accounting Method">
                        FAM Accounting Method
                      </MenuItem>
                      <MenuItem value="FAM Depreciation Method 1">
                        FAM Depreciation Method 1
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      FAM ASSET
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="FAM DEPRECIATION HISTORY"
                    >
                      <MenuItem value="list">List</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button capitalize">
                  New FAM Asset
                </Button>
                <Button className="blue-button">Attach</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionCustomData}
              columns={salesOrderFamAssetTable}
              perPage={5}
              refreshCounter={0}
            />
        
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <Box className="viewDetilsBox">
              <Grid container className="mb-2" spacing={2}>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Custom Default View">
                        Custom Default View
                      </MenuItem>
                      <MenuItem value="Custom Default View">
                        Default View
                      </MenuItem>
                      <MenuItem value="Custom Default View">
                        Default View
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={4} className="m-b-10">
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      JOURNAL REJECT REASON
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="JOURNAL REJECT REASON"
                    >
                      <MenuItem value="list">List</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button capitalize">
                  New journal Reject Reason
                </Button>
                <Button className="blue-button">Attach</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionCustomData}
              columns={salesOrderCustomJournalRejectReasonTable}
              refreshCounter={0}
            />
          </TabPanel>
       
          <TabPanel value={tabIndex} index={2}>
            <Box className="viewDetilsBox">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Custom Default View">
                        Default View
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      FAM DEPRECIATION HISTORY
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="FAM Depreciation History"
                    >
                      <MenuItem value="list">List</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button capitalize">
                  New journal Reject Reason
                </Button>
                <Button className="blue-button">Attach</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionCustomData}
              columns={salesOrderFAMDepreciationHistoryTable}
              perPage={5}
              refreshCounter={0}
            />
          </TabPanel>
        </Box> */}
      </Box>
    </>
  );
}
